import { IState } from '..';
import { IOption } from '../../components/Select';

export function getProductOptions(state: IState, itemIds: string[]): IOption[] {
  return itemIds.reduce<IOption[]>((arr, itemId) => {
    const p = state.products.productHash[itemId];
    if (p) {
      arr = [...arr, { label: p.itemId, secondaryLabel: p.description, value: itemId }];
    }

    return arr;
  }, []);
}
